module.exports = __webpack_public_path__ + "static/img/company_2.d3569a0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/company_2.webp
// module id = 4dQC
// module chunks = 1